/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module, Node, IModuleProps, INodeProps } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IPromoBannerProps } from '../definition-extensions/promo-banner.ext.props.autogenerated';
import { IBannerMessagesData, IPromoBannerResources } from '@msdyn365-commerce-modules/promo-banner';

export interface IPromoBannerViewProps extends IPromoBannerProps<{}> {
    promoBannerProps: IModuleProps;
    contentProps: INodeProps;
    bannerMessages: IBannerMessagesData[];
    promoBannerTextProps: INodeProps;
    promoBannerLinksProps: INodeProps;
    carouselProps: INodeProps;
    closeButton?: React.ReactNode;
    className: string;
    promoBannerText: string;
    resources: IPromoBannerResources;
    onDismiss(): void;
    handleText(): void;
    handleLinks(): void;
}
const PromoBannerView: React.FC<IPromoBannerViewProps> = props => {
    const {
        promoBannerProps,
        contentProps,
        closeButton,
        bannerMessages,
        promoBannerTextProps,
        promoBannerLinksProps,
        carouselProps,
        promoBannerText,
        handleLinks,
        handleText,
        config: { orderTracking, becomeBuisnessPartner, promotionalText },
        context: {
            request: {
                user: { isAuthenticated }
            }
        }
    } = props;

    const slides =
        bannerMessages &&
        bannerMessages.map((message, index) => {
            return (
                <Node {...contentProps} key={index} aria-live='polite' role='marquee'>
                    {/* VSI CUSTOMIZAITON START ADD TWO CONFIGS ORDER TRACKING AND BUISNESS PARTNER*/}
                    <div className='promo-banner-container'>
                        {promotionalText && (
                            <div className='promo-text-container' title={promotionalText}>
                                <span className='promo-text'>{promotionalText}</span>
                            </div>
                        )}
                        <div className='links-container'>
                            <div className='uan-container'>
                                <span className='sr-only'>{promoBannerText}</span>
                                {message.text && <Node {...promoBannerTextProps} text={message.text} onClick={handleText} />}
                                {message.links && message.links.length > 0 && (
                                    <Node {...promoBannerLinksProps} links={message.links} onClick={handleLinks} />
                                )}
                            </div>
                            {orderTracking && (
                                <a
                                    title='Order Tracking'
                                    className={`Tracking ${isAuthenticated ? 'show-text' : 'hide-text'}`}
                                    href={orderTracking && orderTracking?.linkUrl?.destinationUrl}
                                >
                                    <span className='link-text'>{orderTracking?.linkText}</span>
                                </a>
                            )}
                            {!isAuthenticated && becomeBuisnessPartner && (
                                <a
                                    title='Become Buisness partner'
                                    className={`buisness-partner-link ${isAuthenticated ? 'show-text' : 'hide-text'}`}
                                    href={becomeBuisnessPartner && becomeBuisnessPartner?.linkUrl?.destinationUrl}
                                >
                                    <span className='link-text'>{becomeBuisnessPartner?.linkText}</span>
                                </a>
                            )}
                        </div>
                        {/* VSI CUSTOMIZAITON END */}
                    </div>
                </Node>
            );
        });

    return (
        <Module {...promoBannerProps}>
            <Node {...carouselProps} items={slides} />
            {closeButton}
        </Module>
    );
};
export default PromoBannerView;
